
import Navigation from '../../components/feature/Navigation';
import HeroSlideshow from '../../components/feature/HeroSlideshow';
import ServicesSection from './components/ServicesSection';
import CastSection from './components/CastSection';
import SystemSection from './components/SystemSection';
import AccessSection from './components/AccessSection';
import ContactSection from './components/ContactSection';
import RecruitSection from './components/RecruitSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      <main>
        <section id="home">
          <HeroSlideshow />
        </section>
        <ServicesSection />
        <CastSection />
        <SystemSection />
        <AccessSection />
        <ContactSection />
        <RecruitSection />
      </main>
      <Footer />
    </div>
  );
}